import CrudTable from '../../components/CrudTable';

// QT#9: layout sắp xếp vị trí hàng hoá trong cửa tiệm.
export default function LayoutAdmin() {
  return (
    <CrudTable
      title="🗺️ Layout vị trí hàng hoá trong cửa tiệm"
      table="store_layout"
      orderBy="sort_order"
      ascending
      defaults={{ sort_order: 0 }}
      columns={[
        { key: 'zone_code', label: 'Mã khu', type: 'text' },
        { key: 'zone_name', label: 'Tên khu vực', type: 'text', required: true },
        { key: 'description', label: 'Mô tả vị trí', type: 'textarea' },
        { key: 'products_note', label: 'Hàng hoá trưng bày', type: 'textarea' },
        { key: 'image_url', label: 'Ảnh sơ đồ (URL)', type: 'text', inTable: false },
        { key: 'sort_order', label: 'Thứ tự', type: 'number' },
      ]}
    />
  );
}
